import "./NavigationBar.style.css"

// React Bootstrap Icons
import { List, PersonFill, PhoneFlip } from "react-bootstrap-icons"

// React Bootstrap
import { Dropdown } from "react-bootstrap";

// React Router Dom
import { useNavigate } from "react-router-dom";


const NavigationBar = ({ type }) => {
    const navigate = useNavigate();

    const handleSignOut = () => {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("userData");

        return navigate("/");
    }

    const toggleSideBar = () => {
        const elementSideBar = document.querySelector(".side-bar");
        elementSideBar.classList.toggle("hidden");

        const elementContents = document.querySelector(".contents");
        elementContents.classList.toggle("filled");
        return 1;
    }

    return (
        <nav id="navigation-bar" className="navigation-bar">
            <div className="d-flex align-items-center justify-content-center">
                <div className="nav-brand">
                    <h4>Aulia Printing</h4>
                </div>
                <div className="nav-toggle" onClick={toggleSideBar}><List size={32} /></div>
            </div>
            <div className="nav-items">
                <div className="nav-switch" onClick={() => type === "personal" ? navigate("/business/dashboard") : navigate("/personal/dashboard")}>
                    <PhoneFlip size={20} color="#FFF" />
                </div>
                <Dropdown>
                    <Dropdown.Toggle className="nav-profile">
                        <PersonFill size={24} color="#006A71" />
                    </Dropdown.Toggle>
                    
                    <Dropdown.Menu className="mt-1">
                        {/* <Dropdown.Item href="#">Action</Dropdown.Item>
                        <Dropdown.Item href="#">Another action</Dropdown.Item>
                        <Dropdown.Divider /> */}
                        <Dropdown.Item href="#" className="text-danger fw-bold" onClick={handleSignOut}>Sign Out</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </nav>
    )
}

export default NavigationBar